import { Box, SimpleGrid, Stack, Title } from "@mantine/core";
import { liveArchive } from "@/content/live";
import { EmptyState } from "@/components/common/EmptyState";
import { LiveTile } from "@/components/live/LiveTile";
import { PageHero } from "@/components/layout/PageHero";
import { PageContainer } from "@/components/layout/PageContainer";

export default function LiveIndex() {
  const vrShows = liveArchive.filter((l) => l.format === "vr");
  const otherShows = liveArchive.filter((l) => l.format !== "vr");
  const empty = liveArchive.length === 0;

  return (
    <>
      <PageHero
        title="Live"
        subtitle={
          empty
            ? "VR DJ-set archive — clips coming soon."
            : "Watch 7MD live sets."
        }
      />
      <PageContainer navOffset={false}>
        <Stack gap="xl">
          {empty ? (
            <EmptyState
              title="No clips yet"
              body="VR show recordings are being edited and will appear here as they're released."
            />
          ) : (
            <>
              {vrShows.length > 0 && (
                <Box>
                  <Title order={2} size="h3" mb="sm">
                    VR shows
                  </Title>
                  <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="md">
                    {vrShows.map((s) => (
                      <LiveTile key={s.slug} show={s} />
                    ))}
                  </SimpleGrid>
                </Box>
              )}

              {otherShows.length > 0 && (
                <Box>
                  <Title order={2} size="h3" mb="sm">
                    Other live
                  </Title>
                  <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="md">
                    {otherShows.map((s) => (
                      <LiveTile key={s.slug} show={s} />
                    ))}
                  </SimpleGrid>
                </Box>
              )}
            </>
          )}
        </Stack>
      </PageContainer>
    </>
  );
}
